import { useTranslation } from 'react-i18next';
import { Outlet } from '@tanstack/react-router';
import { useDocumentParams } from 'app/router/params';
import { NavPills, NavItem } from 'app/components';

export const PermissionsLayout = () => {
  const { t } = useTranslation('project-details');
  const { documentId } = useDocumentParams();

  const items: NavItem[] = [
    { text: t('users.nav-link.section-permissions'), to: '/documents/$documentId/permissions/sections', params: { documentId } },
    { text: t('users.nav-link.tagging-access'), to: '/documents/$documentId/permissions/tags', params: { documentId } },
    { text: t('users.nav-link.document-permissions'), to: '/documents/$documentId/permissions/documents', params: { documentId } },
    { text: t('users.nav-link.access-logs'), to: '/documents/$documentId/permissions/access', params: { documentId } },
  ];

  return (
    <>
      <NavPills items={items} className="d-inline-flex" />
      <Outlet />
    </>
  );
};
